import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-columns">
          <div className="footer-column">
            <h3 className="column-title">COMPANY INFO</h3>
            <ul className="footer-links">
              <li><Link to="/about" onClick={toTop}>About danecay</Link></li>
              <li><Link to="/privacy" onClick={toTop}>Privacy Policy</Link></li>
              <li><Link to="/terms" onClick={toTop}>Terms of Use</Link></li>
              <li><Link to="/cookies" onClick={toTop}>Cookie Policy</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="column-title">HELP &amp; SUPPORT</h3>
            <ul className="footer-links">
              <li><Link to="/shipping" onClick={toTop}>Shipping</Link></li>
              <li><Link to="/returns" onClick={toTop}>Returns</Link></li>
              <li><Link to="/faq" onClick={toTop}>FAQs</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="column-title">CUSTOMER CARE</h3>
            <ul className="footer-links">
              <li><Link to="/contact" onClick={toTop}>Contact Us</Link></li>
              <li><a href="mailto:core@danecay.shop">core@danecay.shop</a></li>
            </ul>
          </div>

          <div className="footer-column brand-column">
            <h3 className="column-title">DANECAY HONG KONG</h3>
            <p className="footer-address">
              Hong Kong<br />
              <a href="mailto:core@danecay.shop">core@danecay.shop</a>
            </p>
          </div>
        </div>

        <div className="footer-payments" aria-label="Supported payment methods">
          <span>Secure payments supported:</span>
          <span className="payment-badge">VISA</span>
          <span className="payment-badge">Mastercard</span>
          <span className="payment-badge">AMEX</span>
          <span className="payment-badge">Discover</span>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© {new Date().getFullYear()} danecay. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
